/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector , connect } from 'react-redux';
import Header from "@gerenciatd/next.components.header-r";
import Footer from "@gerenciatd/next.components.footer";
import MetaData from '@gerenciatd/next.app-controller.meta-data';
import getSeo from "@gerenciatd/next13.adabyron.custo.get-seo";
import Head from "next/head";
import TextInfo, {
  TEXT_INFO_ALIGN,
  TEXT_INFO_DISPLAY,
  TEXT_INFO_KIND,
  TEXT_INFO_SIZE,
  TEXT_INFO_FONT_WEIGHT,
  TEXT_INFO_COLOR,
} from "@gerenciatd/next.components.text-info";
import IconLabel, {
  ICON_LABEL_FONT_TYPE,
  ICON_LABEL_POSITION,
} from "@gerenciatd/next.components.icon-label";
import {
  BUTTON_TYPE,
  BUTTON_HEIGHT,
  BUTTON_WIDTH,
} from "@gerenciatd/next.components.button-n";
import { getByName } from "@gerenciatd/next.adabyron.custo.get-by-name";
import Icon, {
  ICON_ID,
  ICON_KIND,
  ICON_COLOR,
} from "@gerenciatd/next.components.icon";
import {
  actions as mainActions,
  SONDA_KIND,
} from "@gerenciatd/next.app-controller.reducers-sagas.main-reducer-r";
import Label from "@gerenciatd/next.components.label";
import Price from "@gerenciatd/next.components.price";
import CustomLink from "@gerenciatd/next.components.custom-link";
import Call4Selling, {
  KIND,
  VIEW_OPTIONS,
} from "@gerenciatd/next.components.call-4-selling";
import BannerOfertas from "@/components/banner-ofertas";
import CustomizerComponent from "@gerenciatd/next.components.customizer-component";
import Faq from "@gerenciatd/next.components.faqs-n";
import Slider from "@/components/Slider/";
import AlarmFeature from "@/components/AlarmFeature";
import AlarmFeatureView from "@/components/AlarmFeatureView";
import ALARM_FEATURES from "@/constants/alarmfeatures1_antiokupas.json";
import ALARM_FEATURES_VIEW from "@/constants/alarmfeatures2_antiokupas.json";
import {
  BOTTOMSLIDESETTINGS,
  UPPERSLIDESETTINGS,
} from "@/constants/setting_sliders";
import CustomHead from "@/components/CustomHead/CustomHead";
import StaticBar from "@components/StaticBar";
import Image from '@gerenciatd/next.components.image-n';
import BottomBar from "@components/BottomBar";
import { END } from "redux-saga";
import { wrapper } from "@/store";


const MAIN_TAGGING_INFO = {
  componentProduct: "alarmas",
  componentName: "",
  componentVariation: "all",
  componentContent: "",
  componentePerso: "",
};

const ACTIVITY_ID = "Banner_particulares-movistar-prosegur-alarmas-antiokupas";
const AlarmaAntiOkupas = ({
  bannerOfertaProps,
  activeSlide,
  headerProps,
  seoInfo,
  breadcrumbsProps,
}) => {
  const dispatch = useDispatch();
  const [isSCXLoaded, setIsSCXLoaded] = useState(false);

  useEffect(() => {
    if (window && window.SCX && !isSCXLoaded) {
      setIsSCXLoaded(true);
    } else if (!isSCXLoaded) {
      document.addEventListener("SCX_CREATED", () => {
        setIsSCXLoaded(true);
      });
    }
    if (window && window.IC) {
      window.IC.findPlaceholdersCtzFirst();
      window.IC.reloadCustomizer(undefined, false);
    }
  });
  useEffect(() => {
    dispatch(
      mainActions.setCurrentSeo(seoInfo)
    );
  },[]);

  let initialState = null;
  if (bannerOfertaProps) {
    initialState = {
      status: "success",
      componentData: bannerOfertaProps,
      component: BannerOfertas,
    };
  }
  return (
      <>
          <CustomHead />
          <MetaData seoInfo={seoInfo} />
          <Header {...breadcrumbsProps} {...headerProps} />
          <CustomizerComponent
              activityId={ACTIVITY_ID}
              component={BannerOfertas}
              componentName="banner-oferta"
              dataMock={initialState}
          />
          {/*<StaticBar
              colorBar="#0B2739"
              urlImage="https://movistar.es/estaticos/imagenes/fichas-producto/soteira/pisos/logo-prosegur-alarmas-blanco.png"
              text={{
                  copy: "¡Contrata tu 2ª alarma y consigue un 10% de descuento PARA SIEMPRE en la primera!",
                  color: TEXT_INFO_COLOR.WHITE,
                  size: TEXT_INFO_SIZE.TITLE5,
              }}
            />*/}
          <div className="banda-beneficios">
              <div className="icon">
                  <Icon
                      id={ICON_ID.CamaraSeguridad}
                      kind={ICON_KIND.MEDIUM}
                      size={30}
                      color={ICON_COLOR.WHITE}
                  />
                  <TextInfo
                      text="Asistencia Inmediata"
                      kind={TEXT_INFO_KIND.SPAN}
                      align={TEXT_INFO_ALIGN.CENTER}
                      size={TEXT_INFO_SIZE.TITLE5}
                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                      color={TEXT_INFO_COLOR.WHITE}
                  />
              </div>
              <div className="icon">
                  <Icon
                      id={ICON_ID.Vigilancia}
                      kind={ICON_KIND.MEDIUM}
                      size={30}
                      color={ICON_COLOR.WHITE}
                  />
                  <TextInfo
                      text="Aviso a policía 24h"
                      kind={TEXT_INFO_KIND.SPAN}
                      align={TEXT_INFO_ALIGN.CENTER}
                      size={TEXT_INFO_SIZE.TITLE5}
                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                      color={TEXT_INFO_COLOR.WHITE}
                  />
              </div>
              <div className="icon">
                  <Icon
                      id={ICON_ID.Inhibicion}
                      kind={ICON_KIND.MEDIUM}
                      size={30}
                      color={ICON_COLOR.WHITE}
                  />
                  <TextInfo
                      text="Alarma Inteligente"
                      kind={TEXT_INFO_KIND.SPAN}
                      align={TEXT_INFO_ALIGN.CENTER}
                      size={TEXT_INFO_SIZE.TITLE5}
                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                      color={TEXT_INFO_COLOR.WHITE}
                  />
              </div>
          </div>
          <div className="description">
              <div className="container texto-inicial">
                  <div className="title">
                      <TextInfo
                          text="Protege tu hogar con nuestra alarma anti okupas"
                          align={TEXT_INFO_ALIGN.CENTER}
                          display={TEXT_INFO_DISPLAY.BLOCK}
                          kind={TEXT_INFO_KIND.HEADING}
                          level={2}
                          size={TEXT_INFO_SIZE.TITLE2}
                          fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                          color={TEXT_INFO_COLOR.GREEN}
                      />
                  </div>
                  <div className="title">
                      <TextInfo
                          text="Descubre la alarma anti okupas más rápida de actuar ante una intrusión"
                          align={TEXT_INFO_ALIGN.CENTER}
                          display={TEXT_INFO_DISPLAY.BLOCK}
                          kind={TEXT_INFO_KIND.PARAGRAPH}
                          size={TEXT_INFO_SIZE.TITLE45}
                          fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                          color={TEXT_INFO_COLOR.GREEN}
                      />
                  </div>
                  <div className="subtitle">
                      <TextInfo
                          text="La clave está en la rapidez de reacción una vez confirmada la posible okupación"
                          align={TEXT_INFO_ALIGN.CENTER}
                          display={TEXT_INFO_DISPLAY.BLOCK}
                          kind={TEXT_INFO_KIND.PARAGRAPH}
                          size={TEXT_INFO_SIZE.TITLE45}
                          fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                          color={TEXT_INFO_COLOR.GREY_5}
                      />
                  </div>
                  <div className="features">
                      <div className="row">
                          <div className="col-sm-12 col-xs-12 col-features">
                              <div className="col-container">
                                  <div className="feature">
                                      <div className="icon">
                                          <Icon
                                              id="24h"
                                              kind={ICON_KIND.MEDIUM}
                                              size={70}
                                              color={ICON_COLOR.BLUE_A}
                                          />
                                          <TextInfo
                                              text="Disponibilidad Total"
                                              kind={TEXT_INFO_KIND.SPAN}
                                              align={TEXT_INFO_ALIGN.CENTER}
                                              size={TEXT_INFO_SIZE.TITLE5}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.BOLD
                                              }
                                              color={TEXT_INFO_COLOR.GREY_5}
                                          />
                                      </div>
                                      <div className="text">
                                          <TextInfo
                                              text="Nuestra alarma anti okupación protege tu hogar 24 horas al día."
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.GREY_5}
                                              align={TEXT_INFO_ALIGN.CENTER}
                                          />
                                      </div>
                                  </div>
                                  <div className="feature">
                                      <div className="icon">
                                          <Icon
                                              id={ICON_ID.Inhibicion}
                                              kind={ICON_KIND.MEDIUM}
                                              size={70}
                                              color={ICON_COLOR.BLUE_A}
                                          />
                                          <TextInfo
                                              text="Llegamos antes que la Policía"
                                              kind={TEXT_INFO_KIND.SPAN}
                                              align={TEXT_INFO_ALIGN.CENTER}
                                              size={TEXT_INFO_SIZE.TITLE5}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.BOLD
                                              }
                                              color={TEXT_INFO_COLOR.GREY_5}
                                          />
                                      </div>
                                      <div className="text">
                                          <TextInfo
                                              text="Nuestra Central Receptora de Alarmas avisa a la Policía si comprobamos cualquier intrusión okupación."
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.GREY_5}
                                              align={TEXT_INFO_ALIGN.CENTER}
                                          />
                                      </div>
                                  </div>
                                  <div className="feature">
                                      <div className="icon">
                                          <Icon
                                              id={ICON_ID.Restart}
                                              kind={ICON_KIND.MEDIUM}
                                              size={70}
                                              color={ICON_COLOR.BLUE_A}
                                          />
                                          <TextInfo
                                              text="Respuesta inmediata"
                                              kind={TEXT_INFO_KIND.SPAN}
                                              align={TEXT_INFO_ALIGN.CENTER}
                                              size={TEXT_INFO_SIZE.TITLE5}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.BOLD
                                              }
                                              color={TEXT_INFO_COLOR.GREY_5}
                                          />
                                      </div>
                                      <div className="text">
                                          <TextInfo
                                              text="Respondemos de manera inmediata y en 29 segundos."
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.GREY_5}
                                              align={TEXT_INFO_ALIGN.CENTER}
                                          />
                                      </div>
                                  </div>
                                  <div className="feature">
                                      <div className="icon">
                                          <Icon
                                              id={ICON_ID.EscudoSeguro}
                                              kind={ICON_KIND.MEDIUM}
                                              size={70}
                                              color={ICON_COLOR.BLUE_A}
                                          />
                                          <TextInfo
                                              text="Servicio Custodia de Llaves"
                                              kind={TEXT_INFO_KIND.SPAN}
                                              align={TEXT_INFO_ALIGN.CENTER}
                                              size={TEXT_INFO_SIZE.TITLE5}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.BOLD
                                              }
                                              color={TEXT_INFO_COLOR.GREY_5}
                                          />
                                      </div>
                                      <div className="text">
                                          <TextInfo
                                              text="Con nuestros servicio de Custodia de llaves un vigilante motorizado podrá abrir la puerta de la casa a la Policía."
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.GREY_5}
                                              align={TEXT_INFO_ALIGN.CENTER}
                                          />
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          {/* Sección seguro antiocupas */}
          <div className="grey-back app-movistar-prosegur">
              <div className="container container-news">
                  <div className="title-app">
                      <TextInfo
                          text="Garantía Antiocupación con seguro frente a la ocupación"
                          align={TEXT_INFO_ALIGN.CENTER}
                          display={TEXT_INFO_DISPLAY.BLOCK}
                          kind={TEXT_INFO_KIND.HEADING}
                          level={2}
                          size={TEXT_INFO_SIZE.TITLE2}
                          fontType={TEXT_INFO_FONT_WEIGHT.REGULAR}
                          color={TEXT_INFO_COLOR.GREEN}
                      />
                  </div>
                  <br />
                  <TextInfo
                      text="Movistar Prosegur Alarmas es la primera y única alarma con Garantía Antiocupación que <b>disuade, protege, actúa</b> y, ahora también, se compromete contra las ocupaciones regalándote una <b>póliza de seguro de Línea Directa Aseguradora contra la ocupación ilegal de la vivienda</b>."
                      align={TEXT_INFO_ALIGN.CENTER}
                      display={TEXT_INFO_DISPLAY.BLOCK}
                      kind={TEXT_INFO_KIND.PARAGRAPH}
                      size={TEXT_INFO_SIZE.TITLE5}
                      fontType={TEXT_INFO_FONT_WEIGHT.REGULAR}
                      color={TEXT_INFO_COLOR.GREY_4}
                  />
                  <br />
                  <div className="row features app">
                      <div className="col-sm-6 col-xs-12 app-prosegur-list">
                          <div className="description">
                              <TextInfo
                                  text="¿Qué incluye el seguro frente a la ocupación?"
                                  display={TEXT_INFO_DISPLAY.BLOCK}
                                  kind={TEXT_INFO_KIND.PARAGRAPH}
                                  size={TEXT_INFO_SIZE.TITLE4}
                                  fontType={TEXT_INFO_FONT_WEIGHT.BOLD}
                                  color={TEXT_INFO_COLOR.GREY_6}
                              />
                              <br />
                              <TextInfo
                                  text="En el caso improbable de que ocupen tu casa, la póliza cubre:"
                                  display={TEXT_INFO_DISPLAY.BLOCK}
                                  kind={TEXT_INFO_KIND.PARAGRAPH}
                                  size={TEXT_INFO_SIZE.TITLE5}
                                  fontType={TEXT_INFO_FONT_WEIGHT.REGULAR}
                                  color={TEXT_INFO_COLOR.GREY_4}
                              />
                          </div>
                          <div className="list-container">
                              <ul className="list">
                                  <li>
                                      <TextInfo
                                          text="Asistencia jurídica y gastos legales."
                                          align={TEXT_INFO_ALIGN.LEFT}
                                          display={TEXT_INFO_DISPLAY.BLOCK}
                                          kind={TEXT_INFO_KIND.PARAGRAPH}
                                          size={TEXT_INFO_SIZE.TITLE5}
                                          fontType={
                                              TEXT_INFO_FONT_WEIGHT.REGULAR
                                          }
                                          color={TEXT_INFO_COLOR.GREY_4}
                                      />
                                  </li>
                                  <li>
                                      <TextInfo
                                          text="Responsabilidad civil."
                                          align={TEXT_INFO_ALIGN.LEFT}
                                          display={TEXT_INFO_DISPLAY.BLOCK}
                                          kind={TEXT_INFO_KIND.PARAGRAPH}
                                          size={TEXT_INFO_SIZE.TITLE5}
                                          fontType={
                                              TEXT_INFO_FONT_WEIGHT.REGULAR
                                          }
                                          color={TEXT_INFO_COLOR.GREY_4}
                                      />
                                  </li>
                                  <li>
                                      <TextInfo
                                          text="Gastos de suministros del hogar ocupado."
                                          align={TEXT_INFO_ALIGN.LEFT}
                                          display={TEXT_INFO_DISPLAY.BLOCK}
                                          kind={TEXT_INFO_KIND.PARAGRAPH}
                                          size={TEXT_INFO_SIZE.TITLE5}
                                          fontType={
                                              TEXT_INFO_FONT_WEIGHT.REGULAR
                                          }
                                          color={TEXT_INFO_COLOR.GREY_4}
                                      />
                                  </li>
                                  <li>
                                      <TextInfo
                                          text="Costes de alojamiento hasta recuperar
                                  tu hogar."
                                          align={TEXT_INFO_ALIGN.LEFT}
                                          display={TEXT_INFO_DISPLAY.BLOCK}
                                          kind={TEXT_INFO_KIND.PARAGRAPH}
                                          size={TEXT_INFO_SIZE.TITLE5}
                                          fontType={
                                              TEXT_INFO_FONT_WEIGHT.REGULAR
                                          }
                                          color={TEXT_INFO_COLOR.GREY_4}
                                      />
                                  </li>
                                  <li>
                                      <TextInfo
                                          text="Rehabilitación de tu vivienda una
                                  vez recuperada."
                                          align={TEXT_INFO_ALIGN.LEFT}
                                          display={TEXT_INFO_DISPLAY.BLOCK}
                                          kind={TEXT_INFO_KIND.PARAGRAPH}
                                          size={TEXT_INFO_SIZE.TITLE5}
                                          fontType={
                                              TEXT_INFO_FONT_WEIGHT.REGULAR
                                          }
                                          color={TEXT_INFO_COLOR.GREY_4}
                                      />
                                  </li>
                              </ul>
                          </div>
                      </div>
                      <div className="col-sm-6 col-xs-12 app-prosegur">
                          <div className="pic">
                              <Image
                                  src="/estaticos/imagenes/fichas-producto/alarmas/sello-garantia-antiocupacion-azul-230x230.png"
                                  alt="app Movistar Prosegur Alarmas"
                                  layout="fill"
                                  objectFit="cover"
                                  className="img"
                              />
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          {/* Fin Sección seguro antiocupas */}
          <BottomBar url="/particulares/movistar-prosegur-alarmas/alarmas-anti-ocupas" />
          <div className="grey-back prevenir">
              <div className="container">
                  <div className="title">
                      <TextInfo
                          text="¿Cómo podemos prevenir la okupación?"
                          align={TEXT_INFO_ALIGN.CENTER}
                          display={TEXT_INFO_DISPLAY.BLOCK}
                          kind={TEXT_INFO_KIND.HEADING}
                          level={2}
                          size={TEXT_INFO_SIZE.TITLE3}
                          fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                          color={TEXT_INFO_COLOR.GREY_5}
                      />
                  </div>
                  <div className="text">
                      <TextInfo
                          text="La okupación es un problema real en España ya que el caso de viviendas ocupadas ha aumentado de manera notable. Un okupa puede ocasionar desperfectos en tu vivienda y declararse insolvente después, lo que te puede provocar pérdidas económicas importantes. Movistar Prosegur Alarmas pone a tu disposición una serie de elementos que previenen esta situación."
                          align={TEXT_INFO_ALIGN.CENTER}
                          display={TEXT_INFO_DISPLAY.BLOCK}
                          kind={TEXT_INFO_KIND.PARAGRAPH}
                          size={TEXT_INFO_SIZE.TITLE45}
                          fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                          color={TEXT_INFO_COLOR.GREY_5}
                      />
                  </div>
                  <div className="features prevenir">
                      <div className="item item-l">
                          <div className="title">
                              <TextInfo
                                  text="Placas disuasorias"
                                  display={TEXT_INFO_DISPLAY.BLOCK}
                                  kind={TEXT_INFO_KIND.HEADING}
                                  level={3}
                                  size={TEXT_INFO_SIZE.TITLE45}
                                  fontType={TEXT_INFO_FONT_WEIGHT.BOLD}
                                  color={TEXT_INFO_COLOR.GREY_5}
                                  align={TEXT_INFO_ALIGN.CENTER}
                              />
                          </div>
                          <div className="image">
                              <div className="pic">
                                  <Image
                                      src="/estaticos/imagenes/fichas-producto/soteira/antiocupas/placa-pc.png"
                                      alt="Sistema Armado Inteligente"
                                      layout="fill"
                                      objectFit="cover"
                                      className="img"
                                  />
                              </div>
                          </div>
                          <div className="text">
                              <TextInfo
                                  text="Sabrán que cuentas con la seguridad de un experto"
                                  kind={TEXT_INFO_KIND.PARAGRAPH}
                                  align={TEXT_INFO_ALIGN.CENTER}
                                  size={TEXT_INFO_SIZE.CAPTION1}
                                  fontType={TEXT_INFO_FONT_WEIGHT.REGULAR}
                                  color={TEXT_INFO_COLOR.GREY_5}
                              />
                          </div>
                      </div>
                      <div className="item item-m">
                          <div className="title">
                              <TextInfo
                                  text="Detector Magnético"
                                  display={TEXT_INFO_DISPLAY.BLOCK}
                                  kind={TEXT_INFO_KIND.HEADING}
                                  level={3}
                                  size={TEXT_INFO_SIZE.TITLE45}
                                  fontType={TEXT_INFO_FONT_WEIGHT.BOLD}
                                  color={TEXT_INFO_COLOR.GREY_5}
                                  align={TEXT_INFO_ALIGN.CENTER}
                              />
                          </div>
                          <div className="image">
                              <div className="pic">
                                  <Image
                                      src="/estaticos/imagenes/fichas-producto/soteira/antiocupas/detector-pc.png"
                                      alt="Sistema Armado Inteligente"
                                      layout="fill"
                                      objectFit="cover"
                                      className="img"
                                  />
                              </div>
                          </div>
                          <div className="text">
                              <TextInfo
                                  text="Activa la alarma antes de entrar, si se intenta abrir una puerta o ventana."
                                  kind={TEXT_INFO_KIND.PARAGRAPH}
                                  align={TEXT_INFO_ALIGN.CENTER}
                                  size={TEXT_INFO_SIZE.CAPTION1}
                                  fontType={TEXT_INFO_FONT_WEIGHT.REGULAR}
                                  color={TEXT_INFO_COLOR.GREY_5}
                              />
                          </div>
                      </div>
                      <div className="item item-r">
                          <div className="title">
                              <TextInfo
                                  text="Sirena antiokupas:"
                                  display={TEXT_INFO_DISPLAY.BLOCK}
                                  kind={TEXT_INFO_KIND.HEADING}
                                  level={3}
                                  size={TEXT_INFO_SIZE.TITLE45}
                                  fontType={TEXT_INFO_FONT_WEIGHT.BOLD}
                                  color={TEXT_INFO_COLOR.GREY_5}
                                  align={TEXT_INFO_ALIGN.CENTER}
                              />
                          </div>
                          <div className="image">
                              <div className="pic">
                                  <Image
                                      src="/estaticos/imagenes/fichas-producto/soteira/antiocupas/sirena-pc.png"
                                      alt="Sirena Antiokupas"
                                      layout="fill"
                                      objectFit="cover"
                                      className="img"
                                  />
                              </div>
                          </div>
                          <div className="text">
                              <TextInfo
                                  text="Se acciona en caso de salto de alarma alertando a vecinos de alrededor."
                                  kind={TEXT_INFO_KIND.PARAGRAPH}
                                  align={TEXT_INFO_ALIGN.CENTER}
                                  size={TEXT_INFO_SIZE.CAPTION1}
                                  fontType={TEXT_INFO_FONT_WEIGHT.REGULAR}
                                  color={TEXT_INFO_COLOR.GREY_5}
                              />
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div className="container">
              <div className="titleCotizador">
                  <TextInfo
                      text="Calcula tu precio en 1 minuto"
                      align={TEXT_INFO_ALIGN.CENTER}
                      display={TEXT_INFO_DISPLAY.BLOCK}
                      kind={TEXT_INFO_KIND.HEADING}
                      size={TEXT_INFO_SIZE.TITLE2}
                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                      color={TEXT_INFO_COLOR.GREEN}
                  />
              </div>
              <div className="formulario">
                  <div
                      id="customizer"
                      className="customizer"
                      ctz-creativity="Cotizador_MPA-DistriAlarmas_next"
                      ctz-backup="Cotizador_MPA-DistriAlarmas_next"
                      ctz-id="65eta973x-xkh3l1eru-azdrnex5t-n8kng4cno-hn7cevjty-8qpueu4am"
                  />
              </div>
          </div>
          <div className="container cards">
              <div className="title card-prices">
                  <TextInfo
                      text="Elige la alarma para casa que mejor se adapte a tu tipo de vivienda"
                      align={TEXT_INFO_ALIGN.CENTER}
                      display={TEXT_INFO_DISPLAY.BLOCK}
                      kind={TEXT_INFO_KIND.HEADING}
                      level={2}
                      size={TEXT_INFO_SIZE.TITLE2}
                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                      color={TEXT_INFO_COLOR.GREEN}
                  />
              </div>
              <div className="subtitle">
                  <TextInfo
                      text="Movistar Prosegur Alarmas te ofrece un sistema de seguridad adaptado a las necesidades específicas de tu hogar, un servicio de alarmas para casas personalizado para tu tranquilidad y protección."
                      align={TEXT_INFO_ALIGN.CENTER}
                      display={TEXT_INFO_DISPLAY.BLOCK}
                      kind={TEXT_INFO_KIND.PARAGRAPH}
                      size={TEXT_INFO_SIZE.TITLE5}
                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                      color={TEXT_INFO_COLOR.GREY_5B}
                  />
              </div>
              <div className="row card-choices">
                  <div className="col-sm-4 col-xs-12 l-row">
                      <div className="card">
                          <div className="blue-back back-2">
                              <div className="row-1 title">
                                  <TextInfo
                                      text="Alarma Esencial"
                                      align={TEXT_INFO_ALIGN.LEFT}
                                      display={TEXT_INFO_DISPLAY.BLOCK}
                                      kind={TEXT_INFO_KIND.HEADING}
                                      level={3}
                                      size={TEXT_INFO_SIZE.TITLE4}
                                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                      color={TEXT_INFO_COLOR.WHITE}
                                  />
                              </div>
                              <div className="label-gap" />
                          </div>
                          <div className="row-2 icon-label">
                              <IconLabel
                                  className="link-text"
                                  label="Para viviendas en entreplantas con un único punto de acceso."
                                  labelSize={16}
                                  labelColor={ICON_COLOR.BLACK}
                                  labelFont={ICON_LABEL_FONT_TYPE.REGULAR}
                                  iconColor={ICON_COLOR.BLUE}
                                  id="Ok"
                                  kind="s"
                                  iconSize={30}
                                  labelPosition={ICON_LABEL_POSITION.RIGHT}
                              />
                          </div>
                          <div className="row-2 icon-label">
                              <IconLabel
                                  className="link-text"
                                  label="Seguro frente a la ocupación."
                                  labelSize={16}
                                  labelColor={ICON_COLOR.BLACK}
                                  labelFont={ICON_LABEL_FONT_TYPE.BOLD}
                                  iconColor={ICON_COLOR.BLUE}
                                  id="Seguridad"
                                  kind="s"
                                  iconSize={30}
                                  labelPosition={ICON_LABEL_POSITION.RIGHT}
                              />
                          </div>
                          <div className="row-3 benefits benefits-2">
                              <div className="text">
                                  <TextInfo
                                      text="Servicio de alarma:"
                                      align={TEXT_INFO_ALIGN.LEFT}
                                      display={TEXT_INFO_DISPLAY.BLOCK}
                                      kind={TEXT_INFO_KIND.PARAGRAPH}
                                      size={TEXT_INFO_SIZE.CAPTION1}
                                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                      color={TEXT_INFO_COLOR.BLACK}
                                  />
                                  <ul className="list">
                                      <li>
                                          <TextInfo
                                              text="Panel de comunicación"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="Placas disusorias"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="1 Teclado + 1 Sirena"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="5 Llaves Inteligentes"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="2 Detectores con cámara"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="1 Detector magnético"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="1 SAI (Servicio de Alimentación Ininterrumpido)"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="3 Usuario Servicio ContiGo"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                  </ul>
                                  <div className="blanks-1" />
                              </div>
                          </div>
                          <hr className="divider" />
                          <div className="row-4">
                              <div className="label">
                                  <Label
                                      theme="promo"
                                      inversed={false}
                                      label="Promoción"
                                  />
                              </div>
                              <div className="text">
                                  <TextInfo
                                      text=""
                                      align={TEXT_INFO_ALIGN.LEFT}
                                      display={TEXT_INFO_DISPLAY.BLOCK}
                                      kind={TEXT_INFO_KIND.PARAGRAPH}
                                      size={TEXT_INFO_SIZE.CAPTION2}
                                      fontType={TEXT_INFO_FONT_WEIGHT.BOLD}
                                      color={TEXT_INFO_COLOR.GREY_6}
                                  />
                                  <TextInfo
                                      text="Por:"
                                      align={TEXT_INFO_ALIGN.LEFT}
                                      display={TEXT_INFO_DISPLAY.BLOCK}
                                      kind={TEXT_INFO_KIND.PARAGRAPH}
                                      size={TEXT_INFO_SIZE.CAPTION2}
                                      fontType={TEXT_INFO_FONT_WEIGHT.REGULAR}
                                      color={TEXT_INFO_COLOR.GREY_4}
                                  />
                                  <div className="prices">
                                      <div className="price-1">
                                          <Price
                                              amount={46.9}
                                              unity="€"
                                              color="grey4"
                                              decoration="linethrough"
                                              opacity="op-0-1"
                                              fontType="regular"
                                              size="title03"
                                          />
                                      </div>
                                      <div className="price-2">
                                          <Price
                                              amount={39.9}
                                              unity="€/mes"
                                              frequency="/mes"
                                              color="black"
                                              decoration="none"
                                              opacity="op-0-1"
                                              fontType="bold"
                                              size="title04"
                                          />
                                      </div>
                                  </div>
                                  <div className="text2">
                                      <TextInfo
                                          text="Ahorro de 7€ al mes durante 1 año"
                                          align={TEXT_INFO_ALIGN.LEFT}
                                          display={TEXT_INFO_DISPLAY.BLOCK}
                                          kind={TEXT_INFO_KIND.PARAGRAPH}
                                          size={TEXT_INFO_SIZE.TITLE7}
                                          fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                          color={TEXT_INFO_COLOR.GREY_4}
                                      />
                                  </div>
                              </div>
                              <div className="buttons">
                                  <div className="blue-button">
                                      <Call4Selling
                                          kind={KIND.C2C}
                                          view={VIEW_OPTIONS.BUTTON}
                                          activateCML
                                          buttonProps={{
                                              height: BUTTON_HEIGHT.NORMAL,
                                              label: "Consultar",
                                              labelWidth:
                                                  TEXT_INFO_FONT_WEIGHT.BOLD,
                                              buttonType: BUTTON_TYPE.PRIMARY,
                                              buttonWidth: BUTTON_WIDTH.FULL,
                                          }}
                                          taggingInfo={{
                                              ...MAIN_TAGGING_INFO,
                                              componentProduct:
                                                  "alarma-esencial",
                                              componentName: "product-card",
                                          }}
                                      />
                                  </div>
                                  <div className="info">
                                      <CustomLink
                                          taggingInfo={{
                                              ...MAIN_TAGGING_INFO,
                                              componentProduct:
                                                  "alarma-esencial",
                                              componentName: "product-card",
                                              componentContent:
                                                  "mas-informacion",
                                          }}
                                          title="alarmas-para-aticos-bajos"
                                          href="/particulares/movistar-prosegur-alarmas/alarmas-para-aticos-bajos"
                                      >
                                          <TextInfo
                                              text="Más información"
                                              align={TEXT_INFO_ALIGN.CENTER}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.TITLE7}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.BOLD
                                              }
                                              color={TEXT_INFO_COLOR.BLUE_A}
                                          />
                                      </CustomLink>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div className="col-sm-4 col-xs-12 m-row">
                      <div className="card">
                          <div className="blue-back">
                              <div className="row-1 title">
                                  <TextInfo
                                      text="Alarma Avanzada"
                                      align={TEXT_INFO_ALIGN.LEFT}
                                      display={TEXT_INFO_DISPLAY.BLOCK}
                                      kind={TEXT_INFO_KIND.HEADING}
                                      level={3}
                                      size={TEXT_INFO_SIZE.TITLE4}
                                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                      color={TEXT_INFO_COLOR.WHITE}
                                  />
                              </div>
                              <div className="label">
                                  <Label
                                      customColors={{
                                          color: "green",
                                          background: "white",
                                      }}
                                  />
                              </div>
                          </div>
                          <div className="row-2 icon-label">
                              <IconLabel
                                  className="link-text"
                                  label="Protección total para todo tipo de viviendas: ático, chalet y entreplanta."
                                  labelSize={16}
                                  labelColor={ICON_COLOR.BLACK}
                                  labelFont={ICON_LABEL_FONT_TYPE.REGULAR}
                                  iconColor={ICON_COLOR.BLUE}
                                  id="CasaSegura"
                                  kind="s"
                                  iconSize={30}
                                  labelPosition={ICON_LABEL_POSITION.RIGHT}
                              />
                          </div>
                          <div className="row-2 icon-label">
                              <IconLabel
                                  className="link-text"
                                  label="Seguro frente a la ocupación."
                                  labelSize={16}
                                  labelColor={ICON_COLOR.BLACK}
                                  labelFont={ICON_LABEL_FONT_TYPE.BOLD}
                                  iconColor={ICON_COLOR.BLUE}
                                  id="Seguridad"
                                  kind="s"
                                  iconSize={30}
                                  labelPosition={ICON_LABEL_POSITION.RIGHT}
                              />
                          </div>
                          <div className="row-3 benefits benefits-2">
                              <div className="text">
                                  <TextInfo
                                      text="Servicio de alarma:"
                                      align={TEXT_INFO_ALIGN.LEFT}
                                      display={TEXT_INFO_DISPLAY.BLOCK}
                                      kind={TEXT_INFO_KIND.PARAGRAPH}
                                      size={TEXT_INFO_SIZE.CAPTION1}
                                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                      color={TEXT_INFO_COLOR.BLACK}
                                  />
                                  <ul className="list">
                                      <li>
                                          <TextInfo
                                              text="Panel de comunicación"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="Placas disusorias"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="1 Teclado con sirena"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="5 Llaves Inteligentes"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="3 Detectores con cámara"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="1 Detector magnético"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="1 SAI (Servicio de Alimentación Ininterrumpido)"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="5 Usuarios Servicio ContiGo"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="1 Detector de humo"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="1 Cámara móvil 360&deg; con Reconocimiento Inteligente"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                  </ul>
                                  <div className="blanks-2" />
                              </div>
                          </div>
                          <hr className="divider" />
                          <div className="row-4">
                              <div className="label">
                                  <Label
                                      theme="promo"
                                      inversed={false}
                                      label="Promoción"
                                  />
                              </div>
                              <div className="text">
                                  <TextInfo
                                      text=""
                                      align={TEXT_INFO_ALIGN.LEFT}
                                      display={TEXT_INFO_DISPLAY.BLOCK}
                                      kind={TEXT_INFO_KIND.PARAGRAPH}
                                      size={TEXT_INFO_SIZE.CAPTION2}
                                      fontType={TEXT_INFO_FONT_WEIGHT.BOLD}
                                      color={TEXT_INFO_COLOR.GREY_6}
                                  />
                                  <TextInfo
                                      text="Desde:"
                                      align={TEXT_INFO_ALIGN.LEFT}
                                      display={TEXT_INFO_DISPLAY.BLOCK}
                                      kind={TEXT_INFO_KIND.PARAGRAPH}
                                      size={TEXT_INFO_SIZE.CAPTION2}
                                      fontType={TEXT_INFO_FONT_WEIGHT.REGULAR}
                                      color={TEXT_INFO_COLOR.GREY_4}
                                  />
                                  <div className="prices">
                                      <div className="price-1">
                                          <Price
                                              amount={54.9}
                                              unity="€"
                                              color="grey4"
                                              decoration="linethrough"
                                              opacity="op-0-1"
                                              fontType="regular"
                                              size="title03"
                                          />
                                      </div>
                                      <div className="price-2">
                                          <Price
                                              amount={39.9}
                                              unity="€/mes"
                                              frequency="/mes"
                                              color=""
                                              decoration="none"
                                              opacity="op-0-1"
                                              fontType="bold"
                                              size="title04"
                                          />
                                      </div>
                                  </div>
                                  <div className="text2">
                                      <TextInfo
                                          text="Ahorro de 15€ al mes durante 1 año"
                                          align={TEXT_INFO_ALIGN.LEFT}
                                          display={TEXT_INFO_DISPLAY.BLOCK}
                                          kind={TEXT_INFO_KIND.PARAGRAPH}
                                          size={TEXT_INFO_SIZE.TITLE7}
                                          fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                          color={TEXT_INFO_COLOR.GREY_4}
                                      />
                                  </div>
                              </div>
                              <div className="buttons">
                                  <div className="blue-button">
                                      <Call4Selling
                                          kind={KIND.C2C}
                                          activateCML
                                          view={VIEW_OPTIONS.BUTTON}
                                          buttonProps={{
                                              label: "Consultar",
                                              buttonType: BUTTON_TYPE.PRIMARY,
                                              buttonWidth: BUTTON_WIDTH.FULL,
                                          }}
                                          taggingInfo={{
                                              ...MAIN_TAGGING_INFO,
                                              componentProduct:
                                                  "alarma-avanzada",
                                              componentName: "product-card",
                                          }}
                                      />
                                  </div>
                                  <div className="info">
                                      <CustomLink
                                          taggingInfo={{
                                              ...MAIN_TAGGING_INFO,
                                              componentProduct:
                                                  "alarma-avanzada",
                                              componentName: "product-card",
                                              componentContent:
                                                  "mas-informacion",
                                          }}
                                          title="alarmas-para-pisos"
                                          href="/particulares/movistar-prosegur-alarmas/alarmas-para-pisos"
                                      >
                                          <TextInfo
                                              text="Más información"
                                              align={TEXT_INFO_ALIGN.CENTER}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.TITLE7}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.BOLD
                                              }
                                              color={TEXT_INFO_COLOR.BLUE_A}
                                          />
                                      </CustomLink>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div className="col-sm-4 col-xs-12 r-row">
                      <div className="card">
                          <div className="blue-back">
                              <div className="row-1 title">
                                  <TextInfo
                                      text="Alarma Avanzada Plus"
                                      align={TEXT_INFO_ALIGN.LEFT}
                                      display={TEXT_INFO_DISPLAY.BLOCK}
                                      level={3}
                                      size={TEXT_INFO_SIZE.TITLE4}
                                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                      color={TEXT_INFO_COLOR.WHITE}
                                  />
                              </div>
                          </div>
                          <div className="row-2 icon-label">
                              <IconLabel
                                  className="link-text"
                                  label="Protección total para viviendas con espacios exteriores: ático, chalet y entreplanta."
                                  labelSize={16}
                                  labelColor={ICON_COLOR.BLACK}
                                  labelFont={ICON_LABEL_FONT_TYPE.REGULAR}
                                  iconColor={ICON_COLOR.BLUE}
                                  id="CamaraSeguridad"
                                  kind="m"
                                  iconSize={30}
                                  labelPosition={ICON_LABEL_POSITION.RIGHT}
                              />
                          </div>
                          <div className="row-2 icon-label">
                              <IconLabel
                                  className="link-text"
                                  label="Seguro frente a la ocupación."
                                  labelSize={16}
                                  labelColor={ICON_COLOR.BLACK}
                                  labelFont={ICON_LABEL_FONT_TYPE.BOLD}
                                  iconColor={ICON_COLOR.BLUE}
                                  id="Seguridad"
                                  kind="s"
                                  iconSize={30}
                                  labelPosition={ICON_LABEL_POSITION.RIGHT}
                              />
                          </div>
                          <div className="row-3 benefits">
                              <div className="text">
                                  <TextInfo
                                      text="Servicio de alarma:"
                                      align={TEXT_INFO_ALIGN.LEFT}
                                      display={TEXT_INFO_DISPLAY.BLOCK}
                                      kind={TEXT_INFO_KIND.PARAGRAPH}
                                      size={TEXT_INFO_SIZE.CAPTION1}
                                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                      color={TEXT_INFO_COLOR.BLACK}
                                  />
                                  <ul className="list">
                                      <li>
                                          <TextInfo
                                              text="Panel de comunicación"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="Placas disusorias"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="1 teclado con sirena"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="5 Llaves Inteligentes"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="3 Detectores con cámara"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="2 detectores magnéticos inerciales"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="1 SAI (Servicio de Alimentación Ininterrumpido)"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="6 Usuario Servicio ContiGo"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="1 Detector de humo"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="1 Mando"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="1 Detector exterior con cámara"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="1 Cámara móvil 360&deg; con Reconocimiento Inteligente"
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.CAPTION1}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                  </ul>
                              </div>
                          </div>
                          <hr className="divider" />
                          <div className="row-4">
                              <div className="label">
                                  <Label
                                      theme="promo"
                                      inversed={false}
                                      label="Promoción"
                                  />
                              </div>
                              <div className="text">
                                  <TextInfo
                                      text=""
                                      align={TEXT_INFO_ALIGN.LEFT}
                                      display={TEXT_INFO_DISPLAY.BLOCK}
                                      kind={TEXT_INFO_KIND.PARAGRAPH}
                                      size={TEXT_INFO_SIZE.CAPTION2}
                                      fontType={TEXT_INFO_FONT_WEIGHT.BOLD}
                                      color={TEXT_INFO_COLOR.GREY_6}
                                  />
                                  <TextInfo
                                      text="Desde:"
                                      align={TEXT_INFO_ALIGN.LEFT}
                                      display={TEXT_INFO_DISPLAY.BLOCK}
                                      kind={TEXT_INFO_KIND.PARAGRAPH}
                                      size={TEXT_INFO_SIZE.CAPTION2}
                                      fontType={TEXT_INFO_FONT_WEIGHT.REGULAR}
                                      color={TEXT_INFO_COLOR.GREY_4}
                                  />
                                  <div className="prices">
                                      <div className="price-1">
                                          <Price
                                              amount={61.9}
                                              unity="€"
                                              color="grey4"
                                              decoration="linethrough"
                                              opacity="op-0-1"
                                              fontType="regular"
                                              size="title03"
                                          />
                                      </div>
                                      <div className="price-2">
                                          <Price
                                              amount={46.9}
                                              unity="€/mes"
                                              frequency="/mes"
                                              color=""
                                              decoration="none"
                                              opacity="op-0-1"
                                              fontType="bold"
                                              size="title04"
                                          />
                                      </div>
                                  </div>
                                  <div className="text2">
                                      <TextInfo
                                          text="Ahorro de 15€ al mes durante 1 año"
                                          align={TEXT_INFO_ALIGN.LEFT}
                                          display={TEXT_INFO_DISPLAY.BLOCK}
                                          kind={TEXT_INFO_KIND.PARAGRAPH}
                                          size={TEXT_INFO_SIZE.TITLE7}
                                          fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                          color={TEXT_INFO_COLOR.GREY_4}
                                      />
                                  </div>
                              </div>
                              <div className="buttons">
                                  <div className="blue-button">
                                      <Call4Selling
                                          kind={KIND.C2C}
                                          view={VIEW_OPTIONS.BUTTON}
                                          activateCML
                                          buttonProps={{
                                              label: "Consultar",
                                              buttonType: BUTTON_TYPE.PRIMARY,
                                              buttonWidth: BUTTON_WIDTH.FULL,
                                          }}
                                          taggingInfo={{
                                              ...MAIN_TAGGING_INFO,
                                              componentProduct:
                                                  "alarma-avanzada-exteriores",
                                              componentName: "product-card",
                                          }}
                                      />
                                  </div>
                                  <div className="info">
                                      <CustomLink
                                          taggingInfo={{
                                              ...MAIN_TAGGING_INFO,
                                              componentProduct:
                                                  "alarma-avanzada-exteriores",
                                              componentName: "product-card",
                                              componentContent:
                                                  "mas-informacion",
                                          }}
                                          title="alarmas-para-chalets"
                                          href="/particulares/movistar-prosegur-alarmas/alarmas-para-chalets"
                                      >
                                          <TextInfo
                                              text="Más información"
                                              align={TEXT_INFO_ALIGN.CENTER}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.TITLE7}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.BOLD
                                              }
                                              color={TEXT_INFO_COLOR.BLUE_A}
                                          />
                                      </CustomLink>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div className="grey-back camara">
              <div className="container">
                  <div className="title">
                      <TextInfo
                          text="Prueba nuestra cámara móvil 360&deg; con Reconocimiento Inteligente"
                          align={TEXT_INFO_ALIGN.CENTER}
                          display={TEXT_INFO_DISPLAY.BLOCK}
                          kind={TEXT_INFO_KIND.HEADING}
                          level={2}
                          size={TEXT_INFO_SIZE.TITLE2}
                          fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                          color={TEXT_INFO_COLOR.GREY_7}
                      />
                  </div>
                  <div className="row features">
                      <div className="col-sm-6 col-xs-12 camara-movil">
                          <div className="pic">
                              <Image
                                  src="/estaticos/imagenes/fichas-producto/soteira/distributiva/470x400-camara-movil.jpg"
                                  alt="Cámara móvil"
                                  layout="fill"
                                  objectFit="cover"
                                  className="img"
                              />
                          </div>
                      </div>
                      <div className="col-sm-6 col-xs-12 camara-movil-list">
                          <div className="description">
                              <TextInfo
                                  text="Ahora, aun estando fuera de casa, nuestra alarma inteligente incluye una nueva tecnología de reconocimiento inteligente con la que recibirás notificaciones en tiempo real personalizables en la App de Movistar Prosegur Alarmas cuando nuestra cámara detecte movimientos y sonidos no cotidianos."
                                  align={TEXT_INFO_ALIGN.LEFT}
                                  display={TEXT_INFO_DISPLAY.BLOCK}
                                  kind={TEXT_INFO_KIND.PARAGRAPH}
                                  size={TEXT_INFO_SIZE.TITLE6}
                                  fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                  color={TEXT_INFO_COLOR.GREY_5}
                              />
                          </div>
                          <div className="list-container">
                              <TextInfo
                                  text="El Reconocimiento inteligente permite:"
                                  align={TEXT_INFO_ALIGN.LEFT}
                                  display={TEXT_INFO_DISPLAY.BLOCK}
                                  kind={TEXT_INFO_KIND.PARAGRAPH}
                                  size={TEXT_INFO_SIZE.CAPTION1}
                                  fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                  color={TEXT_INFO_COLOR.GREY_5}
                              />
                              <ul className="list">
                                  <li>
                                      <TextInfo
                                          text="Comprobar en tiempo real si alguien entra en tu casa."
                                          align={TEXT_INFO_ALIGN.LEFT}
                                          display={TEXT_INFO_DISPLAY.BLOCK}
                                          kind={TEXT_INFO_KIND.PARAGRAPH}
                                          size={TEXT_INFO_SIZE.CAPTION1}
                                          fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                          color={TEXT_INFO_COLOR.GREY_5}
                                      />
                                  </li>
                                  <li>
                                      <TextInfo
                                          text="Ver movimientos de personas y mascotas en la vivienda."
                                          align={TEXT_INFO_ALIGN.LEFT}
                                          display={TEXT_INFO_DISPLAY.BLOCK}
                                          kind={TEXT_INFO_KIND.PARAGRAPH}
                                          size={TEXT_INFO_SIZE.CAPTION1}
                                          fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                          color={TEXT_INFO_COLOR.GREY_5}
                                      />
                                  </li>
                                  <li>
                                      <TextInfo
                                          text="Reconocer sonidos como el llanto, ladrido de un perro, rotura de un cristal o una sirena enviándote una notificación personalizada en tu app."
                                          align={TEXT_INFO_ALIGN.LEFT}
                                          display={TEXT_INFO_DISPLAY.BLOCK}
                                          kind={TEXT_INFO_KIND.PARAGRAPH}
                                          size={TEXT_INFO_SIZE.CAPTION1}
                                          fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                          color={TEXT_INFO_COLOR.GREY_5}
                                      />
                                  </li>
                                  <li>
                                      <TextInfo
                                          text="Función Habla/Escucha para comunicarte en cualquier momento."
                                          align={TEXT_INFO_ALIGN.LEFT}
                                          display={TEXT_INFO_DISPLAY.BLOCK}
                                          kind={TEXT_INFO_KIND.PARAGRAPH}
                                          size={TEXT_INFO_SIZE.CAPTION1}
                                          fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                          color={TEXT_INFO_COLOR.GREY_5}
                                      />
                                  </li>
                                  <li>
                                      <TextInfo
                                          text="Puedes situarla donde te interese en cada momento."
                                          align={TEXT_INFO_ALIGN.LEFT}
                                          display={TEXT_INFO_DISPLAY.BLOCK}
                                          kind={TEXT_INFO_KIND.PARAGRAPH}
                                          size={TEXT_INFO_SIZE.CAPTION1}
                                          fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                          color={TEXT_INFO_COLOR.GREY_5}
                                      />
                                  </li>
                                  <li>
                                      <TextInfo
                                          text="Tu <b>privacidad está 100% garantizada</b>, solo tu recibirás las notificaciones en tu app."
                                          align={TEXT_INFO_ALIGN.LEFT}
                                          display={TEXT_INFO_DISPLAY.BLOCK}
                                          kind={TEXT_INFO_KIND.PARAGRAPH}
                                          size={TEXT_INFO_SIZE.CAPTION1}
                                          fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                          color={TEXT_INFO_COLOR.GREY_5}
                                      />
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div className="acuda">
              <div className="container">
                  <div className="title">
                      <TextInfo
                          text="Servicio de Vigilante de Intervención Inmediata: </br>Llegamos antes que la Policía"
                          align={TEXT_INFO_ALIGN.CENTER}
                          display={TEXT_INFO_DISPLAY.BLOCK}
                          kind={TEXT_INFO_KIND.HEADING}
                          level={2}
                          size={TEXT_INFO_SIZE.TITLE2}
                          fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                          color={TEXT_INFO_COLOR.GREY_5}
                      />
                  </div>
                  <div className="row features">
                      <div className="col-sm-6 col-xs-12 image">
                          <div className="pic">
                              <Image
                                  src="/estaticos/imagenes/fichas-producto/soteira/antiocupas/acuda-pc.jpg"
                                  alt="Servicio Acuda"
                                  layout="fill"
                                  objectFit="cover"
                                  className="img"
                              />
                          </div>
                      </div>
                      <div className="col-sm-6 col-xs-12 description">
                          <div className="div">
                              <div className="text">
                                  <TextInfo
                                      text="Con este servicio, un vigilante motorizado se desplazará rápidamente para verificar el salto de alarma anti okupas.</br></br>Ideal para residencias que se encuentran inhabitadas durante largos periodos de tiempo.</br></br>Además, el servicio Custodia de Llaves guardará una copia de tu juego de llaves facilitando la entrada a las Fuerzas de Seguridad."
                                      align={TEXT_INFO_ALIGN.LEFT}
                                      display={TEXT_INFO_DISPLAY.BLOCK}
                                      kind={TEXT_INFO_KIND.PARAGRAPH}
                                      size={TEXT_INFO_SIZE.TITLE6}
                                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                      color={TEXT_INFO_COLOR.BLACK}
                                  />
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div className="contiGo">
              <div className="container">
                  <div className="title">
                      <TextInfo
                          text="Servicio ContiGo"
                          align={TEXT_INFO_ALIGN.CENTER}
                          display={TEXT_INFO_DISPLAY.BLOCK}
                          kind={TEXT_INFO_KIND.HEADING}
                          level={2}
                          size={TEXT_INFO_SIZE.TITLE2}
                          fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                          color={TEXT_INFO_COLOR.GREY_5}
                      />
                  </div>
                  <div className="row features">
                      <div className="col-sm-6 col-xs-12 description">
                          <div className="div">
                              <div className="text">
                                  <TextInfo
                                      text="Ahora servicio ContiGo incluido. La seguridad personal desde tu móvil. Es un sistema de protección integrado en la app Movistar Prosegur Alarmas con el que estarás protegido fuera del hogar."
                                      align={TEXT_INFO_ALIGN.LEFT}
                                      display={TEXT_INFO_DISPLAY.BLOCK}
                                      kind={TEXT_INFO_KIND.PARAGRAPH}
                                      size={TEXT_INFO_SIZE.TITLE6}
                                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                      color={TEXT_INFO_COLOR.BLACK}
                                  />
                              </div>
                              <div className="list-div">
                                  <ul className="list">
                                      <li>
                                          <TextInfo
                                              text="<b>Botón SOS:</b> pulsa el Botón SOS de tu app si te encuentras en peligro y recibirás ayuda de manera inmediata."
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.TITLE6}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                      <li>
                                          <TextInfo
                                              text="<b>Cuenta atrás:</b> actívala en trayectos donde te sientas inseguro y todos nuestros profesionales te protegerán durante todo el recorrido."
                                              align={TEXT_INFO_ALIGN.LEFT}
                                              display={TEXT_INFO_DISPLAY.BLOCK}
                                              kind={TEXT_INFO_KIND.PARAGRAPH}
                                              size={TEXT_INFO_SIZE.TITLE6}
                                              fontType={
                                                  TEXT_INFO_FONT_WEIGHT.LIGHT
                                              }
                                              color={TEXT_INFO_COLOR.BLACK}
                                          />
                                      </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                      <div className="col-sm-6 col-xs-12 image">
                          <div className="pic">
                              <Image
                                  src="/estaticos/imagenes/fichas-producto/soteira/distributiva/470x400-contiGo.jpg"
                                  alt="ContigoGo"
                                  layout="fill"
                                  objectFit="cover"
                                  className="img"
                              />
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div className="carrusel">
              <div className="title">
                  <TextInfo
                      text="¿Qué incluye el pack de alarma para pisos?"
                      align={TEXT_INFO_ALIGN.CENTER}
                      display={TEXT_INFO_DISPLAY.BLOCK}
                      kind={TEXT_INFO_KIND.HEADING}
                      level={2}
                      size={TEXT_INFO_SIZE.TITLE2}
                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                      color={TEXT_INFO_COLOR.GREEN}
                  />
              </div>
              <div className="container">
                  <Slider
                      className="upper-slider"
                      dots={false}
                      arrows={false}
                      activeSlide={activeSlide}
                      onClick={activeSlide}
                      {...UPPERSLIDESETTINGS}
                  >
                      {ALARM_FEATURES.map((singleFeature, index) => {
                          const selected = index === activeSlide;
                          return (
                              <AlarmFeature
                                  {...singleFeature}
                                  selected={selected}
                              />
                          );
                      })}
                  </Slider>
                  <Slider
                      className="bottom-slider"
                      activeSlide={activeSlide}
                      {...BOTTOMSLIDESETTINGS}
                  >
                      {ALARM_FEATURES_VIEW.map((singleFeature) => {
                          return <AlarmFeatureView {...singleFeature} />;
                      })}
                  </Slider>
              </div>
              <div className="text">
                  <TextInfo
                      text="Se recomienda el hogar con fibra y"
                      align={TEXT_INFO_ALIGN.CENTER}
                      display={TEXT_INFO_DISPLAY.INLINE}
                      kind={TEXT_INFO_KIND.PARAGRAPH}
                      size={TEXT_INFO_SIZE.TITLE6}
                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                      color={TEXT_INFO_COLOR.BLACK}
                  />
                  <CustomLink
                      taggingInfo={{
                          ...MAIN_TAGGING_INFO,
                          componentProduct: "alarma-anti-ocupas",
                          componentName: "customLink",
                          componentContent: "Recomendaciones",
                      }}
                      title="hgu"
                      href="https://www.movistar.es/particulares/movil/moviles/hgu"
                  >
                      <TextInfo
                          text=" Router Smart Wifi "
                          align={TEXT_INFO_ALIGN.JUSTIFY}
                          display={TEXT_INFO_DISPLAY.INLINE}
                          kind={TEXT_INFO_KIND.PARAGRAPH}
                          fontType={TEXT_INFO_FONT_WEIGHT.REGULAR}
                          size={TEXT_INFO_SIZE.TITLE6}
                          color={TEXT_INFO_COLOR.BLUE_A}
                      />
                  </CustomLink>
                  <TextInfo
                      text="para un óptimo disfrute del kit completo con todas sus funcionalidades."
                      align={TEXT_INFO_ALIGN.CENTER}
                      display={TEXT_INFO_DISPLAY.INLINE}
                      kind={TEXT_INFO_KIND.PARAGRAPH}
                      size={TEXT_INFO_SIZE.TITLE6}
                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                      color={TEXT_INFO_COLOR.BLACK}
                  />
              </div>
          </div>
          <div className="grey-back app-movistar-prosegur">
              <div className="container container-news">
                  <div className="title">
                      <TextInfo
                          text="Controla si un okupa entra en tu hogar con la app de Movistar Prosegur Alarmas"
                          align={TEXT_INFO_ALIGN.CENTER}
                          display={TEXT_INFO_DISPLAY.BLOCK}
                          kind={TEXT_INFO_KIND.HEADING}
                          level={2}
                          size={TEXT_INFO_SIZE.TITLE2}
                          fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                          color={TEXT_INFO_COLOR.GREEN}
                      />
                  </div>
                  <div className="app-prosegur">
                      <div className="image">
                          <div className="pic">
                              <Image
                                  src="/estaticos/imagenes/fichas-producto/soteira/app-prosegur-240x240.jpg"
                                  alt="app Movistar Prosegur Alarmas"
                                  layout="fill"
                                  objectFit="cover"
                                  className="img"
                              />
                          </div>
                      </div>
                      <div className="features">
                          <div className="row1">
                              <div className="item">
                                  <Icon
                                      id={ICON_ID.Seguridad}
                                      kind={ICON_KIND.MEDIUM}
                                      size={50}
                                      color={ICON_COLOR.BLUE_A}
                                  />
                                  <TextInfo
                                      text="Activa y desactiva tu alarma"
                                      kind={TEXT_INFO_KIND.SPAN}
                                      align={TEXT_INFO_ALIGN.CENTER}
                                      size={TEXT_INFO_SIZE.TITLE6}
                                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                      color={TEXT_INFO_COLOR.GREY_5}
                                  />
                              </div>
                              <div className="item">
                                  <Icon
                                      id={ICON_ID.MovilSeguro}
                                      kind={ICON_KIND.MEDIUM}
                                      size={50}
                                      color={ICON_COLOR.BLUE_A}
                                  />
                                  <TextInfo
                                      text="Ve en tiempo real lo que sucede en tu casa"
                                      kind={TEXT_INFO_KIND.SPAN}
                                      align={TEXT_INFO_ALIGN.CENTER}
                                      size={TEXT_INFO_SIZE.TITLE6}
                                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                      color={TEXT_INFO_COLOR.GREY_5}
                                  />
                              </div>
                              <div className="item">
                                  <Icon
                                      id={ICON_ID.Vigilancia}
                                      kind={ICON_KIND.MEDIUM}
                                      size={50}
                                      color={ICON_COLOR.BLUE_A}
                                  />
                                  <TextInfo
                                      text="Recibe ayuda inmediata con el botón SOS"
                                      kind={TEXT_INFO_KIND.SPAN}
                                      align={TEXT_INFO_ALIGN.CENTER}
                                      size={TEXT_INFO_SIZE.TITLE6}
                                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                      color={TEXT_INFO_COLOR.GREY_5}
                                  />
                              </div>
                          </div>
                          <div className="row2">
                              <div className="item">
                                  <Icon
                                      id={ICON_ID.Ok}
                                      kind={ICON_KIND.MEDIUM}
                                      size={50}
                                      color={ICON_COLOR.BLUE_A}
                                  />
                                  <TextInfo
                                      text="Comprueba el estado de tu alarma"
                                      kind={TEXT_INFO_KIND.SPAN}
                                      align={TEXT_INFO_ALIGN.CENTER}
                                      size={TEXT_INFO_SIZE.TITLE6}
                                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                      color={TEXT_INFO_COLOR.GREY_5}
                                  />
                              </div>
                              <div className="item">
                                  <Icon
                                      id={ICON_ID.CamaraSeguridad}
                                      kind={ICON_KIND.MEDIUM}
                                      size={50}
                                      color={ICON_COLOR.BLUE_A}
                                  />
                                  <TextInfo
                                      text="Solicita imágenes de los vídeos detectores"
                                      kind={TEXT_INFO_KIND.SPAN}
                                      align={TEXT_INFO_ALIGN.CENTER}
                                      size={TEXT_INFO_SIZE.TITLE6}
                                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                      color={TEXT_INFO_COLOR.GREY_5}
                                  />
                              </div>
                              <div className="item">
                                  <Icon
                                      id={ICON_ID.Retroceder}
                                      kind={ICON_KIND.MEDIUM}
                                      size={50}
                                      color={ICON_COLOR.BLUE_A}
                                  />
                                  <TextInfo
                                      text="Te acompañamos durante tus trayectos"
                                      kind={TEXT_INFO_KIND.SPAN}
                                      align={TEXT_INFO_ALIGN.CENTER}
                                      size={TEXT_INFO_SIZE.TITLE6}
                                      fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                                      color={TEXT_INFO_COLOR.GREY_5}
                                  />
                              </div>
                          </div>
                      </div>
                  </div>
                  <div className="links-apps">
                      <div className="app">
                          <CustomLink
                              taggingInfo={{
                                  ...MAIN_TAGGING_INFO,
                                  componentProduct: "alarma-anti-ocupas",
                                  componentName: "customLink",
                                  componentContent: "App miMovistar GooglePlay",
                              }}
                              title="playStore app Prosegur"
                              href="https://play.google.com/store/apps/details?id=com.prosegur.alarmas&hl=es&pli=1"
                          >
                              <div className="pic">
                                  <Image
                                      src="/estaticos/imagenes/fichas-producto/soteira/bot-googleplay.png"
                                      alt="Google Play"
                                      layout="fill"
                                      objectFit="cover"
                                      className="img"
                                  />
                              </div>
                          </CustomLink>
                      </div>
                      <div className="app">
                          <CustomLink
                              taggingInfo={{
                                  ...MAIN_TAGGING_INFO,
                                  componentProduct: "alarma-anti-ocupas",
                                  componentName: "customLink",
                                  componentContent: "App miMovistar AppleStore",
                              }}
                              title="appstore app Prosegur"
                              href="https://apps.apple.com/es/app/movistar-prosegur-alarmas/id1491000506"
                          >
                              <div className="pic">
                                  <Image
                                      src="/estaticos/imagenes/fichas-producto/soteira/bot-appstore.png"
                                      alt="Apple Store"
                                      layout="fill"
                                      objectFit="cover"
                                      className="img"
                                  />
                              </div>
                          </CustomLink>
                      </div>
                  </div>
              </div>
          </div>
          <div className="faqs">
              <div className="container">
                  <Faq
                      title="Preguntas frecuentes sobre alarmas antiokupación"
                      titleProps={{
                          color: "green",
                      }}
                      listadoFAQS={[
                          {
                              title: "¿Puedo darme de baja de la alarma anti okupas cuando quiera?",
                              description:
                                  "Puedes darte de baja de Movistar Prosegur Alarmas cuando no lo necesites, aunque estamos seguros de que una vez que lo pruebes no podrás vivir sin tu alarma de hogar.",
                          },
                          {
                              title: "¿Puedo contratar más de una alarma anti okupas?",
                              description:
                                  "Sí, puedes contratar tantas alarmas Movistar Prosegur como domicilios tengas, de forma que puedas tener cubiertas tanto tu casa principal como segundas y sucesivas residencias. Para cada domicilio solo se puede contratar una alarma de Movistar Prosegur Alarmas.",
                          },
                          {
                              title: "¿Qué incluye el Kit de alarmas para anti okupas?",
                              description:
                                  "El Kit para alarmas anti okupas incluye:<ul><li>Alarma Esencial: panel de comunicación, una sirena exterior, placa disuasoria, un teclado+ 1 sirena, una SAI (Sistema de batería auxiliar), 5 llaves inteligentes, 2 detectores con cámara, 1 detector magnético y un usuario de Servicio Contigo.</li><li>Alarma Avanzada: panel de comunicación, una sirena exterior, placa disuasoria, un teclado+ 1 sirena, una SAI (Sistema de batería auxiliar), 5 llaves inteligentes,3 detectores con cámara, 1 detector magnético , dos usuarios de Servicio Contigo, 1 detector de humos y 1 cámara móvil 360&deg; con Reconocimiento Inteligente.</li><li>Alarma Avanzada Plus: panel de comunicación, una sirena exterior, placa disuasoria, un teclado+ 1 sirena, una SAI (Sistema de batería auxiliar), 5 llaves inteligentes,3 detectores con cámara, 1 detector magnético , dos usuarios de Servicio Contigo, 1 detector de humos y 1 cámara móvil 360&deg; con Reconocimiento Inteligente, 1 mando y 2 detectores exteriores con cámara.</li></ul>",
                          },
                          {
                              title: "¿Puedo contratar algún servicio/dispositivo adicional de seguridad con mi alarma antiokupas?",
                              description:
                                  "Sí, puedes reforzar los puntos que más te preocupen de tu hogar en caso de que el tamaño de éste sea más grande de lo recomendado para las alarmas de seguridad que comercializamos. En ese caso, cuando el instalador vaya a tu hogar, puede asesorarte sobre el dispositivo apropiado a tus necesidades de seguridad e instalártelo en ese momento.",
                          },
                      ]}
                      faqItemOptions={{
                          default: {
                              color: {
                                  title: "blue",
                                  icon: "blue",
                              },
                          },
                          activated: {
                              color: {
                                  title: "green",
                                  icon: "green",
                              },
                          },
                      }}
                  />
              </div>
          </div>
          <div className="condiciones-comerciales">
              <div className="container">
                  <div
                      id="customizer"
                      className="customizer"
                      ctz-creativity="legales-prosegur-alarmas-GP"
                      ctz-backup="legales-prosegur-alarmas-GP"
                  />
              </div>
          </div>
          <Footer />
          <style jsx>
              {`
                  .pic {
                      :global(span) {
                          position: relative !important;
                          :global(img) {
                              height: auto !important;
                              width: auto !important;
                              position: relative !important;
                          }
                      }
                  }
                  .banner-oferta {
                      .bannerRow {
                          .infoContainer {
                              .priceContainer {
                                  .gap {
                                      margin-right: 2rem;
                                  }
                              }
                          }
                      }
                  }
                  .banda-beneficios {
                      background-color: var(--color-gp--blue);
                      display: flex;
                      padding: 0.7rem 0;
                      justify-content: space-around;
                  }
                  .container {
                      .titleCotizador {
                          margin-top: 2rem;
                      }
                      .title {
                          margin-top: 2rem;
                      }
                      .subtitle {
                          margin-bottom: 2rem;
                      }
                      .card-choices {
                          display: flex;
                          flex-wrap: wrap;
                          justify-content: center;
                          .l-row,
                          .m-row,
                          .r-row {
                              height: 100%;
                              margin: 1rem;
                              .card {
                                  width: 355px;
                                  border-radius: 10px;
                                  box-shadow: 0px 0px 5px 0px
                                      var(--color-emp--grey1a);
                                  .blue-back {
                                      min-height: 160px;
                                      border-radius: 10px 10px 0 0;
                                      background-color: var(--color-gp--blue);
                                      .title {
                                          margin: 1rem;
                                          padding: 2rem;
                                      }
                                  }
                                  .back-2 {
                                      padding-bottom: 1rem;
                                  }
                                  .green-back {
                                      min-height: 160px;
                                      margin-bottom: 1rem;
                                      border-radius: 10px 10px 0 0;
                                      background-color: var(--color-gp--green);
                                      .title {
                                          margin: 1rem;
                                          padding: 2rem;
                                      }
                                      .label {
                                          padding-left: 3rem;
                                      }
                                  }
                                  .icon-label {
                                      margin: 1rem;
                                      height: 67.5px;
                                  }
                                  .benefits {
                                      height: 327.5px;
                                      margin: 2rem 1.5rem;
                                      .list {
                                          margin-left: 1rem;
                                          margin-top: 1rem;
                                          list-style-type: "+ ";
                                      }
                                  }
                                  .divider {
                                      width: 75%;
                                      margin-left: 2rem;
                                      color: var(--color-emp--grey1a);
                                  }
                                  .divider-l {
                                      padding-bottom: 2.245rem;
                                  }
                                  .row-4 {
                                      margin: 1rem;
                                      .label {
                                          margin: 1rem 0 0 0;
                                      }
                                      .text {
                                          margin: 1rem;
                                      }
                                      .prices {
                                          display: flex;
                                          width: 100%;
                                          justify-content: flex-start;
                                          flex-wrap: wrap;
                                          .price-1 {
                                              margin-right: 0.3rem;
                                          }
                                          .price-1,
                                          .price-2 {
                                              align-self: flex-end;
                                          }
                                      }
                                      .buttons {
                                          padding-bottom: 1rem;
                                          display: flex;
                                          flex-direction: column;
                                          justify-content: space-around;
                                          .info {
                                              margin-top: 1rem;
                                          }
                                      }
                                  }
                              }
                          }
                      }
                      .col-container {
                          display: flex;
                          .feature {
                              width: 100%;
                              margin: 1rem;
                              .icon {
                                  display: flex;
                                  flex-direction: column;
                                  margin-bottom: 1rem;
                              }
                          }
                      }
                      .col-news {
                          padding: 2rem 0;
                          .card-container {
                              margin: 0 1rem;
                              display: flex;
                              justify-content: space-between;
                              align-items: stretch;
                              .card {
                                  width: 100%;
                                  margin: 0 0.5rem;
                                  display: flex;
                                  flex-direction: column;
                                  justify-content: space-between;
                                  box-shadow: 0px 0px 5px 0px
                                      var(--color-emp--grey1a);
                                  border-radius: 4px;
                                  padding: 1rem;
                                  transition: all 0.3s;
                                  &:hover {
                                      transition: all 0.3s;
                                      box-shadow: 0px 0px 5px 0px
                                          var(--color-emp--blue-a);
                                  }
                                  .row {
                                      padding: 2rem 0;
                                  }
                                  .content {
                                      height: 100%;
                                      display: block;
                                      .image {
                                          margin: auto;
                                          height: 200px;
                                          background-size: cover;
                                          background-repeat: no-repeat;
                                          background-position: center;
                                      }
                                      .image-s {
                                          background-size: contain;
                                      }
                                      .text {
                                          margin-top: 0.7rem;
                                          .list {
                                              list-style-type: disc;
                                              margin: 0 0 0 1rem;
                                          }
                                      }
                                  }
                              }
                          }
                      }
                  }
                  .grey-back {
                      background-color: #f4f4f3;
                      &.app-movistar-prosegur {
                          margin: 5rem 0 2rem 0;
                      }
                      .container {
                          .title {
                              padding: 1rem 0;
                          }
                          .features {
                              &.prevenir {
                                  display: flex;
                                  align-content: center;
                                  justify-content: center;
                                  align-items: flex-start;
                                  .item {
                                      display: flex;
                                      flex-direction: column;
                                      align-content: center;
                                      align-items: center;
                                      justify-content: center;
                                      width: 100%;
                                      .foto {
                                          margin: auto;
                                      }
                                      .text {
                                          margin: 0.7rem 0 1.5rem 0;
                                      }
                                  }
                              }
                              .door-list {
                                  height: 100%;
                                  display: flex;
                                  padding: 2rem 0;
                                  flex-direction: column;
                                  justify-content: space-between;
                                  .description {
                                      padding-bottom: 2rem;
                                  }
                                  .li {
                                      display: flex;
                                      align-items: center;
                                      .icon {
                                          margin-right: 1rem;
                                      }
                                  }
                              }
                              .camara-movil {
                                  margin: auto;
                              }
                              .camara-movil-list {
                                  display: flex;
                                  flex-direction: column;
                                  justify-content: space-evenly;
                                  .list {
                                      display: flex;
                                      flex-direction: column;
                                      justify-content: space-evenly;
                                  }
                              }
                          }
                          .door,
                          .app {
                              padding-bottom: 3rem;
                              .door-list,
                              .app-prosegur-list {
                                  display: flex;
                                  flex-direction: column;
                                  justify-content: center;
                                  .list {
                                      padding-top: 2rem;
                                      display: flex;
                                      flex-direction: column;
                                      justify-content: space-evenly;
                                  }
                              }
                          }
                      }
                      .list {
                          color: var(--color-gp--grey5);
                          list-style-type: disc;
                          margin: 0 0 0 1rem;
                      }
                      .app-prosegur {
                          display: flex;
                          justify-content: space-around;
                          align-items: center;
                          flex-direction: row;
                          .image {
                              margin: auto;
                              width: 100%;
                              .foto {
                                  margin: auto;
                              }
                          }
                          .features {
                              display: flex;
                              flex-wrap: wrap;
                              margin: 1rem;
                              justify-content: center;
                              .image {
                                  width: 100%;
                              }
                              .row1,
                              .row2 {
                                  display: flex;
                                  .item {
                                      margin: 1rem;
                                      width: 100%;
                                      display: flex;
                                      flex-direction: column;
                                      justify-content: center;
                                      align-content: center;
                                      align-items: center;
                                  }
                              }
                          }
                      }
                      .links-apps {
                          display: flex;
                          justify-content: flex-end;
                          .app {
                              margin: 0 1rem;
                              &:hover {
                                  transition: all 0.3s;
                                  opacity: 0.7;
                              }
                          }
                      }
                  }
                  .white-back {
                      &.armado-inteligente {
                          margin: 5rem 0 2rem 0;
                      }
                      .container {
                          .app {
                              padding-bottom: 3rem;
                              .door-list {
                                  display: flex;
                                  flex-direction: column;
                                  align-content: center;
                                  justify-content: space-around;
                                  align-items: stretch;
                                  .list {
                                      padding-top: 2rem;
                                      display: flex;
                                      flex-direction: column;
                                      justify-content: space-evenly;
                                  }
                              }
                              .app-prosegur-list {
                                  display: flex;
                                  flex-direction: column;
                                  justify-content: space-evenly;
                                  .description {
                                      padding: 0.5rem 0 0.5rem 0;
                                      display: flex;
                                      flex-direction: column;
                                      justify-content: space-evenly;
                                  }
                                  .seg-digital {
                                      display: flex;
                                      align-content: center;
                                      justify-content: center;
                                  }
                              }
                          }
                      }
                      .list {
                          color: var(--color-gp--grey5);
                          list-style-type: disc;
                          margin: 0 0 0 1rem;
                      }
                  }
                  .contiGo,
                  .acuda {
                      .container {
                          padding: 1rem 0;
                          .features {
                              margin: 2rem 0;
                              .description {
                                  display: flex;
                                  flex-direction: column;
                                  justify-content: space-evenly;
                                  .title {
                                      margin-bottom: 2rem;
                                  }
                                  .list-div {
                                      padding: 1rem;
                                      .list {
                                          list-style-type: disc;
                                          margin: 0 0 0 1rem;
                                      }
                                  }
                              }
                              .image {
                                  display: flex;
                                  align-content: center;
                                  justify-content: center;
                              }
                          }
                      }
                  }
                  .carrusel {
                      .title {
                          margin-bottom: 1.5rem;
                      }
                      .text {
                          text-align: center;
                      }
                  }
                  .condiciones-comerciales {
                      .text {
                          padding: 1rem 0 2rem 0;
                      }
                  }
                  .faqs {
                      li {
                          list-style-type: disc;
                      }
                  }
                  @media screen and (max-width: 1200px) {
                      .card-choices {
                          .cards {
                              width: 460px;
                          }
                      }
                  }
                  @media screen and (max-width: 768px) {
                      .description {
                          .features {
                              .row {
                                  .col-features {
                                      .col-container {
                                          flex-wrap: wrap;
                                      }
                                  }
                              }
                          }
                      }
                      .banda-beneficios {
                          .icon {
                              flex-direction: column;
                          }
                      }
                      .prevenir {
                          .container {
                              .features {
                                  flex-wrap: wrap;
                              }
                          }
                      }
                      .cards {
                          .card-choices {
                              .l-row,
                              .m-row,
                              .r-row {
                                  .card {
                                      width: 100%;
                                      .benefits {
                                          height: auto;
                                      }
                                      .green-back {
                                          min-height: 90px;
                                          border-radius: 10px 10px 0 0;
                                          background-color: var(
                                              --color-gp--green
                                          );
                                          .title {
                                              margin: 0;
                                              padding: 0.9rem;
                                          }
                                          .label {
                                              padding: 0 0 0.5rem 0.5rem;
                                          }
                                      }
                                      .blue-back {
                                          min-height: 90px;
                                          border-radius: 10px 10px 0 0;
                                          background-color: var(
                                              --color-gp--blue
                                          );
                                          .title {
                                              margin: 0;
                                              padding: 0.9rem;
                                          }
                                      }
                                      .row-4 {
                                          padding: 1rem;
                                          width: 100%;
                                      }
                                  }
                              }
                          }
                      }
                      .bottom-container {
                          .bottom {
                              background-position: bottom;
                              min-height: 0;
                              .text-bottom {
                                  justify-items: center;
                                  .text-bottom-2 {
                                      text-align: center;
                                  }
                                  .button-gap {
                                      display: grid;
                                      align-items: center;
                                  }
                              }
                          }
                      }
                      .camara {
                          .container {
                              .features {
                                  padding-bottom: 1.5rem;
                              }
                          }
                      }
                      .contiGo,
                      .acuda {
                          .title {
                              margin: 0 1rem;
                          }
                          .text {
                              margin-left: 1rem;
                          }
                      }
                      .app-movistar-prosegur {
                          .container-news {
                              .app-prosegur {
                                  .image {
                                      display: none;
                                      .foto {
                                          margin: auto;
                                      }
                                  }
                              }
                              .links-apps {
                                  justify-content: center;
                              }
                          }
                      }
                      .faqs {
                          padding: 0;
                          .container {
                              padding: 0;
                          }
                      }
                  }
              `}
          </style>
      </>
  );
};

const mapStateToProps = (state) => ({
  activeSlide: state.ui.sliders.pruebaSlider,
});

const mapDispatchToProps = (dispatch) => ({
  throwSonda: (data) => dispatch(mainActions.throwSonda(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AlarmaAntiOkupas);

export const getStaticProps = wrapper.getStaticProps(async ({ store }) => {
  const modules = await Promise.all([
    await import("@gerenciatd/next13.adabyron.misc.get-static-content"),
    await import("@gerenciatd/next13.normalizers.components-header.sections"),
    await import(
      "@gerenciatd/next13.normalizers.components-header.breadcrumbs"
    ),
    await import(
      "@gerenciatd/next.app-controller.reducers-sagas.header-reducer-r"
    ),
  ]);

  const getStaticContent = modules[0].default;
  const getHeaderSections = modules[1].default;
  const getBreadcrumbs = modules[2].default;
  const headerActions = modules[3].actions;

  const { context } = store.getState().main;

  // HEADER USUAL PROPS
  const urlBreadcrumbs = "/static/json/header/breadcrumbs.json";
  const breadcrumbsInfoJson = await getStaticContent({
    resourcePath: urlBreadcrumbs,
    context,
  });
  const url = "/particulares/movistar-prosegur-alarmas/alarmas-anti-ocupas";
  const breadcrumbsProps = getBreadcrumbs(breadcrumbsInfoJson, url);
  const headerInfoJson = await getStaticContent({
    resourcePath: "/static/json/header/header_plan_r.json",
    context,
  });
  // HEADER REDUX PROPS
  const headerProps = getHeaderSections(headerInfoJson, breadcrumbsProps);
  store.dispatch(headerActions.setupHeaderProps(headerProps));
  const seoInfo = await getSeo({
    context,
    location: `www.movistar.es/particulares/movistar-prosegur-alarmas/alarmas-anti-ocupas`,
  });
  store.dispatch(
    headerActions.getFooterInfo({
      pathname: "/particulares/movistar-prosegur-alarmas/alarmas-anti-ocupas",
    })
  );

  let bannerOfertaProps = null;
  try {
    bannerOfertaProps = await getByName({
      icParams: {
        SEG_NAV: "particulares",
      },
      preRenderEnv: "movistar.es",
      context,
      name: ACTIVITY_ID,
    });
  } catch (err) {
    console.log(err);
  }

  store.dispatch(END);
  await store.sagaTask.toPromise();

  return {
    props: {
      bannerOfertaProps,
      headerProps,
      seoInfo,
      breadcrumbsProps,
    },
  };
});
